export default "__VITE_ASSET__CA8LRpKs__"